"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITicketUserRestriction = exports.TicketUserRole = exports.TicketCommentType = exports.TicketStatus = exports.TicketCustomFields = exports.TicketPriority = exports.TicketType = void 0;
var TicketType;
(function (TicketType) {
    TicketType["TASK"] = "task";
    TicketType["QUESTION"] = "question";
    TicketType["INCIDENT"] = "incident";
    TicketType["PROBLEM"] = "problem";
})(TicketType = exports.TicketType || (exports.TicketType = {}));
var TicketPriority;
(function (TicketPriority) {
    TicketPriority["LOW"] = "low";
    TicketPriority["NORMAL"] = "normal";
    TicketPriority["HIGH"] = "high";
    TicketPriority["URGENT"] = "urgent";
})(TicketPriority = exports.TicketPriority || (exports.TicketPriority = {}));
var TicketCustomFields;
(function (TicketCustomFields) {
    TicketCustomFields[TicketCustomFields["ORDER_ID"] = 360008772953] = "ORDER_ID";
    TicketCustomFields[TicketCustomFields["JOB_ID"] = 360009411354] = "JOB_ID";
    TicketCustomFields[TicketCustomFields["CLAIM_TYPE"] = 360019779514] = "CLAIM_TYPE";
    TicketCustomFields[TicketCustomFields["CLAIM_CATEGORY"] = 360020320073] = "CLAIM_CATEGORY";
    TicketCustomFields[TicketCustomFields["CLAIM_CLOSURE_REASON"] = 360020337834] = "CLAIM_CLOSURE_REASON";
    TicketCustomFields[TicketCustomFields["CLAIM_POST_CODE"] = 360020011934] = "CLAIM_POST_CODE";
    TicketCustomFields[TicketCustomFields["CLAIM_ORDER_REF"] = 360020020174] = "CLAIM_ORDER_REF";
    TicketCustomFields[TicketCustomFields["CLAIM_COMPANY_NAME"] = 360020020194] = "CLAIM_COMPANY_NAME";
    TicketCustomFields[TicketCustomFields["CLAIM_CUSTOMER_NAME"] = 360020018973] = "CLAIM_CUSTOMER_NAME";
    TicketCustomFields[TicketCustomFields["CLAIM_CUSTOMER_EMAIL"] = 360020019153] = "CLAIM_CUSTOMER_EMAIL";
    TicketCustomFields[TicketCustomFields["CLAIM_JOB_TYPE"] = 360020139374] = "CLAIM_JOB_TYPE";
    TicketCustomFields[TicketCustomFields["PARTNER_ID"] = 360020567313] = "PARTNER_ID";
})(TicketCustomFields = exports.TicketCustomFields || (exports.TicketCustomFields = {}));
var TicketStatus;
(function (TicketStatus) {
    TicketStatus["NEW"] = "new";
    TicketStatus["OPEN"] = "open";
    TicketStatus["PENDING"] = "pending";
    TicketStatus["HOLD"] = "hold";
    TicketStatus["SOLVED"] = "solved";
    TicketStatus["CLOSED"] = "closed";
})(TicketStatus = exports.TicketStatus || (exports.TicketStatus = {}));
var TicketCommentType;
(function (TicketCommentType) {
    TicketCommentType["COMMENT"] = "Comment";
    TicketCommentType["VOICE_COMMENT"] = "VoiceComment";
})(TicketCommentType = exports.TicketCommentType || (exports.TicketCommentType = {}));
var TicketUserRole;
(function (TicketUserRole) {
    TicketUserRole["END_USER"] = "end-user";
    TicketUserRole["AGENT"] = "agent";
    TicketUserRole["ADMIN"] = "admin";
})(TicketUserRole = exports.TicketUserRole || (exports.TicketUserRole = {}));
var ITicketUserRestriction;
(function (ITicketUserRestriction) {
    ITicketUserRestriction["ORGANIZATION"] = "organization";
    ITicketUserRestriction["GROUPS"] = "groups";
    ITicketUserRestriction["ASSIGNED"] = "assigned";
    ITicketUserRestriction["REQUESTED"] = "requested";
})(ITicketUserRestriction = exports.ITicketUserRestriction || (exports.ITicketUserRestriction = {}));
//# sourceMappingURL=ticket.js.map